<template>
  <v-row
    :class="{ 'section ma-0': $vuetify.breakpoint.smAndUp && isUserLoggedIn }"
    v-if="isLoading"
  >
    <v-col
      class="px-4"
      cols="12"
      xs="12"
      sm="12"
      :class="
        this.$router === '/newsfeed' || newsFeed.isCommentSetting
          ? 'col-md-9 col-lg-9 col-xl-9 center-content'
          : 'col-md-12 col-lg-12 col-xl-12 center-content'
      "
    >
      <v-card flat>
        <!-- <v-card-title class="header-title">
          <BreadCrumb :name="newsFeed ? newsFeed.title : ''" />
          <v-spacer></v-spacer>
          <div>
            <router-link :to="{ path: isLogin ? '/newsfeed' : '/news-feed' }">
              <v-icon
                style="cursor: pointer"
                color="white"
                class="mr-3"
                size="26"
                >mdi-close-circle-outline</v-icon
              >
            </router-link>
            <router-link
              v-if="newsFeed.priviousId"
              :to="{ path: '/newsfeed/view/' + newsFeed.priviousId._id }"
            >
              <v-icon
                style="cursor: pointer"
                color="white"
                class="mr-1"
                size="26"
                >mdi-arrow-left-circle-outline</v-icon
              >
            </router-link>
            <v-icon v-else disabled color="white" class="mr-1" size="26"
              >mdi-arrow-left-circle-outline</v-icon
            >
            <router-link
              v-if="newsFeed.nextId"
              :to="{ path: '/newsfeed/view/' + newsFeed.nextId._id }"
            >
              <v-icon
                color="white"
                style="cursor: pointer"
                class="ml-1"
                size="26"
                >mdi-arrow-right-circle-outline</v-icon
              >
            </router-link>
            <v-icon v-else disabled color="white" class="ml-1" size="26"
              >mdi-arrow-right-circle-outline</v-icon
            >
          </div>
        </v-card-title> -->
        <v-card-title class="newsfeed-header-title pa-0 ml-4 mr-2 my-5">
          <v-row>
            <v-col cols="10" class="text-left">
              {{ newsFeed.title }}
            </v-col>
            <v-col cols="2" class="text-right">
              <news-feed-action :newsFeedData="newsFeed"></news-feed-action>
            </v-col>
          </v-row>
        </v-card-title>
        <v-card-text>
          <i class="upload-image-box">
            <v-skeleton-loader
              v-if="isImageLoading && newfeedImage.length > 0"
              type="image"
              class="mx-auto"
            ></v-skeleton-loader>
            <img
              class="upload-image-box"
              v-if="newfeedImage.length > 0"
              :src="newfeedImage[0].url"
              @load="isImageLoading = false"
            />
          </i>
          <div
            v-html="newsFeed.description"
            class="ql-editor panel-body text-justify mt-5"
          ></div>

          <video-component
            :videoUrl="newsFeed.videoUrl"
            v-if="newsFeed.videoUrl"
          ></video-component>

          <document-list
            v-if="documents.length > 0"
            class="mt-5"
            :documents="documents"
            :newsFeedData="newsFeed"
          ></document-list>

          <v-chip
            v-if="newsFeed.categoryObj"
            color="#FDAF19"
            class="white--text mt-6"
            >{{ newsFeed.categoryObj.name }}</v-chip
          >
        </v-card-text>
      </v-card>
    </v-col>
    <v-col
      cols="12"
      xs="12"
      sm="12"
      md="3"
      lg="3"
      xl="3"
      :class="$vuetify.breakpoint.mdAndUp ? 'newsfeed-sidebar' : ''"
      v-if="newsFeed.isCommentSetting"
    >
      <v-card outlined class="comments-section">
        <v-card-title class="newsfeed-header-title pa-0 ml-3 mr-2 my-2">
          <v-row>
            <v-col cols="12" class="pt-5 pb-0">
              <span class="ml-1">Comments</span>
            </v-col>
          </v-row>
        </v-card-title>
        <v-divider
          :class="$vuetify.breakpoint.mdAndUp ? 'mx-3' : 'ml-3 mr-10'"
          style="{border-color:#E5E5E5;border-width: thin 0 1px 0;}"
        ></v-divider>
        <v-layout row wrap align-end>
          <v-flex xs11>
            <v-container fluid grid-list-lg class="px-0 pl-3">
              <v-layout row wrap tag="ul" class="position-relative">
                <div v-if="comments.length > 0" class="flex xs12">
                  <comments-list
                    :ref="'commentlist_' + comment._id"
                    :activeReply.sync="activeReply"
                    :key="[$options.name, comment._id].join('_')"
                    :newCommentMap.sync="value_"
                    @input="editComment($event)"
                    class="flex xs12"
                    showReplies
                    v-bind="{ comment }"
                    v-for="comment in comments"
                    :name="[$options.name, comment._id].join('_')"
                    @updateComments="getLatestComments"
                    @updateCommentData="updateCommentdata"
                  />
                </div>
                <v-flex v-else xs11 class="no-comments-msg ml-2 mt-4">
                  <span>Comments not added yet.</span>
                </v-flex>
                <v-flex v-if="isUserLoggedIn" class="comment-form-div">
                  <comment-form
                    :newsfeedId="newsFeed._id"
                    @input="editComment($event)"
                    class="flex xs12"
                    @newsFeedsLatestComment="getLatestComments"
                    :inputField="'comment'"
                  />
                </v-flex>
              </v-layout>
            </v-container>
          </v-flex>
        </v-layout>
      </v-card>
    </v-col>
  </v-row>
  <v-row class="right-panel" v-else>
    <v-col>
      <v-card flat class="dialog-cls">
        <v-container style="height: 600px">
          <v-row class="fill-height" align-content="center" justify="center">
            <v-col class="dialog-title-sm text-center" cols="12"
              >Loading... Please wait</v-col
            >
            <v-col cols="6">
              <v-progress-linear
                color="#344452"
                indeterminate
                rounded
                height="10"
              ></v-progress-linear>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { NewsFeedService } from "@/services";
import store from "@/store";
import { mapGetters } from "vuex";
export default {
  name: "Detail",
  components: {
    NewsFeedAction: () => import("./NewsFeedAction"),
    DocumentList: () => import("./DocumentList"),
    VideoComponent: () => import("@/components/Video"),
    // BreadCrumb: () => import("@/components/BreadCrumb"),
    CommentsList: () => import("./components/CommentsList"),
    commentForm: () => import("./components/CommentForm")
  },
  data() {
    return {
      newsFeed: {},
      isLoading: false,
      isImageLoading: true,
      isLogin: false,
      showRepliesList: false,
      activeReply: null,
      perPage: 10,
      page: 1,
      comments: []
    };
  },
  computed: {
    newfeedImage() {
      return this.newsFeed.media.filter(
        media => media.mediaType === "image" && media.imageType === "BANNER"
      );
    },
    documents() {
      return this.newsFeed.media.filter(media => media.mediaType === "doc");
    },
    ...mapGetters("user", {
      isUserLoggedIn: "isUserLoggedIn"
    }),
    value_: {
      get() {
        if (this.value) return this.value;
        return [];
      },
      set(value) {
        this.$emit("input", value);
      }
    }
  },
  async mounted() {
    this.isLogin = store.state.user.isUserLoggedIn;
    const newsfeed = await NewsFeedService.getNewsFeed(this.$route.params.id);
    this.newsFeed = newsfeed.data.data[0];
    this.isLoading = true;
    if (this.newsFeed.isCommentSetting) this.getComments();
    if (this.$vuetify.breakpoint.smAndUp) {
      this.$parent.$parent.$parent.$refs.header.breadcrumbName = this.newsFeed.title;
    }
  },
  methods: {
    updateCommentdata(commentData) {
      let commentsList = this.comments;
      let commentToEdit = commentsList.find(x => x._id === commentData._id);
      commentToEdit.description = commentData.description;
    },
    getLatestComments() {
      this.page = 1;
      this.getComments();
    },
    editComment(comment) {
      let valueClone = JSON.parse(JSON.stringify(this.value_));
      let index = valueClone.findIndex(v => v.id === comment.id);
      if (index === -1) {
        valueClone.push(comment);
      } else {
        this.$set(valueClone, index, comment);
      }
      this.value_ = valueClone;
    },
    async getComments() {
      //this.comments = [];
      let newsfeedId = this.newsFeed._id;
      const params = {
        newsFeedId: newsfeedId,
        page: parseInt(this.page),
        perPage: this.perPage
      };
      this.$store.dispatch("newsFeedsComment/setNewsFeedId", newsfeedId);
      const newsFeedComments = await NewsFeedService.getNewsFeedComments(
        params
      );
      if (newsFeedComments) {
        this.comments = newsFeedComments.data.data;
      }
      this.page += 1;
    }
  }
};
</script>

<style scoped lang="scss">
.section {
  margin-left: 95px !important;
}
.panel-main {
  height: auto;
}
.scr {
  img.img-section {
    min-width: 100% !important;
    max-height: 320px !important;
  }
}
.imgSection {
  width: 100% !important;
  height: 320px !important;
  background-position: center center !important;
  background-size: cover !important;
}
.v-icon:hover,
.header-title:hover {
  color: #fcae00 !important;
}
.upload-image-box {
  margin: 0 auto;
  display: block;
  text-align: -webkit-center;
  display: block;
  background-size: contain;
  background-position: center;
  overflow: hidden;
}
.comments-section {
  height: 555px;
  border: none;
}
.no-comments-msg {
  text-align: center;
  border: thin solid rgba(0, 0, 0, 0.12);
  border-radius: 4px;
}
.comment-form-div {
  position: absolute;
  bottom: -23px;
  display: contents;
}
.scroll-box {
  height: 370px;
}
.newsfeed-sidebar {
  border-left: thin solid #0000001f;
}
.comments-section .container ul {
  padding-left: 10px !important;
}
</style>
